// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + ({"439":"bfadlib","914":"109d8103"}[chunkId] || chunkId) + "." + {"439":"10079ac4a660caa3be9c","504":"bbd796146e5d1fd886a7","914":"8753400d9f2ee6ed25e4"}[chunkId] + ".js?brotli=allow&ext=.js";
};